<template>
    <v-layout wrap v-if="show==1">
        <v-flex style="margin:auto">
            <v-tabs v-model="matrixTab">
                <v-tab :key="0">
                    DANH SÁCH MA TRẬN ĐÃ TẠO
                </v-tab>
                <v-tab :key="1" @click="getSavedExam">
                    DANH SÁCH ĐỀ ĐÃ TẠO
                </v-tab>
                <v-tabs-items>
                    <v-tab-item :key="0">
                        <div style="text-align: right">
                            <v-btn @click="insertMatrix" class="yoprimary" dark>
                                Tạo ma trận đề
                            </v-btn>
                            <v-btn @click="cancel" color="cancel" class="mx-0">
                                Trở lại
                            </v-btn>
                        </div>
                        <v-data-table :headers="matrixHeaders" :items="matrixBySearch"
                                      class="elevation-1 gru-table fixed-header" hide-actions
                                      :pagination.sync="pagination"
                        >
                            <template slot="headers">
                                <tr>
                                    <th v-for="header in matrixHeaders" :width="header.width" :class="[
                  header.sortable?'column sortable active':'',
                  (header.value == sortField && orderBy=='desc') ? 'desc' : 'asc'
                ]"
                                        @click="changeSort(header)"
                                    >
                                        <div v-if="header.value=='checkbox'" style="text-align: center">
                                            <v-checkbox color="primary" hide-details v-model="selectAll"></v-checkbox>
                                        </div>
                                        <div v-else :style="header.headerStyle">
                                            {{$t(header.text)}}
                                            <v-icon small class="no-print"
                                                    v-if="header.sortable && header.value ==sortField">
                                                arrow_upward
                                            </v-icon>
                                        </div>
                                    </th>
                                </tr>
                                <tr class="grey lighten-3 no-print filter">
                                    <td v-for="header in matrixHeaders" class="text-xs-left gru-filter">
                                        <div v-if="header.search==true" class="border-and-box">
                                            <v-text-field single-line
                                                          hide-details
                                                          :placeholder="'Tìm kiếm' + header.text"
                                                          v-model.trim="matrix[header.value]"
                                                          v-on:keyup.enter="getMatrix"
                                                          dense
                                                          type="text"
                                                          small
                                            />
                                        </div>
                                        <v-icon v-else-if="header.value=='checkbox'">filter_list</v-icon>
                                    </td>
                                </tr>
                            </template>
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-left">{{ props.index +1 + (pagination.page-1) *
                                    pagination.rowsPerPage}}
                                </td>
                                <td class="text-xs-left">{{ props.item.matrix_name }}</td>
                                <td class="text-xs-left">{{ props.item.updated_at | formatDateTime }}</td>
                                <td class="justify-center layout px-0">
                                    <v-btn @click="createExam(props.item.matrix_id)"
                                           class="mx-0" icon small t title="Xem đề thi">
                                        <v-icon color="info">list</v-icon>
                                    </v-btn>
                                    <v-btn @click="viewMatrix(props.item.matrix_id)" icon small title="Xem ma trận"
                                           class="mx-0">
                                        <v-icon color="secondary">visibility</v-icon>
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item :key="1">
                        <v-data-table :headers="examHeaders" :items="lstSavedExam"
                                      class="elevation-1 gru-table fixed-header"
                                      :pagination.sync="examPagination"
                        >
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-left">{{ props.index +1 + (examPagination.page-1) *
                                    examPagination.rowsPerPage}}
                                </td>
                                <td class="text-xs-left">{{ props.item.exam_name }}</td>
                                <td class="text-xs-right">{{ props.item.number_of_question }}</td>
                                <td class="text-xs-left">{{ props.item.created_at | formatDateTime }}</td>
                                <td class="justify-center layout px-0">
                                    <v-btn @click="selectExamId(props.item.exam_id)" title="Chọn đề"
                                           class="mx-0" icon>
                                        <v-icon color="primary">visibility</v-icon>
                                    </v-btn>
                                    <v-btn @click="onDeleteExam(props.item.exam_id)" title="Xóa đề"
                                           class="mx-0" icon>
                                        <v-icon color="error">delete</v-icon>
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>

                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </v-flex>
    </v-layout>
    <v-layout v-else>
        <v-flex>
            <matrix-create :matrix-id="matrixId" @cancel="cancelCreate" :class-id="classId" @save="onSelectExam"
                           @onUpdate="updateMatrixId"/>
        </v-flex>
    </v-layout>
</template>

<script>
    import axios from "axios/index";
    import {message} from "@/shared/message";
    import MemberDetail from "../memberDetail";
    import MatrixCreate from "./matrixCreate";

    export default {
        name: "matrix-page",

        components: {
            MatrixCreate,
            MemberDetail
        },
        props: {
            classId: {
                type: String | Number,
                default: null
            }
        },

        data: () => ({
            sortField: "matrixName",
            orderBy: "desc",
            show: 1,
            matrixTab: 0,
            matrixId: null,
            search: null,
            matrixHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    search: false,
                    value: "index"
                },
                {
                    text: "Tên ma trận",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "matrixName"
                },
                {
                    text: "Ngày cập nhật",
                    align: "left",
                    sortable: true,
                    search: false,
                    value: "createdAt"
                },
                {text: "Lựa chọn", value: "matrixId", align: "center", sortable: false}
            ],
            matrixBySearch: [],
            examHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    search: false,
                    value: "index"
                },
                {
                    text: "Tên đề",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "exam_name"
                },
                {
                    text: "Số câu",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "number_of_question"
                },
                {
                    text: "Ngày tạo",
                    align: "left",
                    sortable: true,
                    search: false,
                    value: "createdAt"
                },
                {text: "Lựa chọn", value: "matrixId", align: "center", sortable: false}
            ],
            lstSavedExam: [],
            matrix: {},
            examPagination: {
                rowsPerPage: 10,
                page: 1,
                orderBy: "exam_name",
                descending: false
            },
            pagination: {
                rowsPerPage: 10,
                page: 1,
                orderBy: "matrix_name",
                descending: false
            },
        }),

        computed: {},

        watch: {},

        mounted() {
        },

        created() {
            this.unsubscribe = this.$store.subscribe((mutation, state) => {
                if (mutation.type == "common/setSearch") {
                    this.search = mutation.payload;
                    this.getMatrix();
                }
            });
            this.getMatrix();
            //this.getSavedExam();
        },

        beforeDestroy() {
            this.unsubscribe();
        },

        methods: {
            changeSort: function (header) {
                if (!header.sortable) {
                    return;
                }
                //console.log(this.sortField + "-" + this.orderBy);
                let descending = true;
                if (this.sortField == header.value) {
                    if (this.orderBy == "asc") {
                        this.orderBy = "desc";
                    } else {
                        this.orderBy = "asc";
                        descending = false;
                    }
                } else {
                    this.sortField = header.value;
                    this.orderBy = "asc";
                    descending = false;
                }
                this.pagination = {
                    rowsPerPage: 10,
                    page: 1,
                    orderBy: header.value,
                    descending: descending
                };
                console.log(this.pagination);

                this.getMatrix();
            },

            getMatrix: function () {
                //let url = process.env.VUE_APP_API_URL + "/matrix/myMatrix?";
                let url = process.env.VUE_APP_YO_LEARN_API + "/list-matrix?token=yoclass&class_id=" + this.classId + "&user_id=" + this.$store.state.auth.user.userId;
                /*
                                if (this.sortField != null) {
                                    url += "&orderBy=" + this.sortField;
                                    if (this.orderBy != null) {
                                        url += "&sort=" + this.orderBy;
                                    }
                                }
                                if(this.matrix.matrixName != null && this.matrix.matrixName != ""){
                                    url += "&search=" + this.matrix.matrixName;
                                } else if (this.search != null && this.search != "") {
                                    url += "&search=" + this.search;
                                }
                */
                axios.get(url).then(
                    data => {
                        this.matrixBySearch = data.data;
                    },
                    error => {
                        message.error(error);
                    }
                )
            },

            updateMatrixId(matrixId) {
                this.matrixId = matrixId;
            },

            getSavedExam: function () {
                let url = process.env.VUE_APP_YO_LEARN_API + "/list-exam-matrix?token=yoclass&class_id=" + this.classId + "&user_id=" + this.$store.state.auth.user.userId;
                axios.get(url).then(
                    data => {
                        this.lstSavedExam = data.data;
                    },
                    error => {
                        message.error(error);
                    }
                )
            },

            getSavedExamOfMatrix: function (matrixId) {
                let url = process.env.VUE_APP_YO_LEARN_API + "/list-exam-matrix?token=yoclass&class_id=" + this.classId + "&user_id=" + this.$store.state.auth.user.userId + "&matrix_id=" + matrixId;
                axios.get(url).then(
                    data => {
                        if (data.data == null || data.data.length == 0) {
                            message.error("Chưa tạo đề cho ma trận");
                        } else {
                            this.lstSavedExam = data.data;
                            this.matrixTab = 1;
                        }
                    },
                    error => {
                        message.error(error);
                    }
                )
            },

            insertMatrix: function () {
                this.matrixId = null;
                this.show = 2;
            },

            createExam: function (matrixId) {
                this.getSavedExamOfMatrix(matrixId);
            },

            onDeleteExam(examId) {
                /*
                                let ob = {
                                    "exam_key":exam.exam_key,
                                    "exam_name":exam.exam_name,
                                    "user_id":this.$store.state.auth.user.userId
                                }
                                let userId= this.$store.state.auth.user.userId;
                                axios.delete(process.env.VUE_APP_YO_LEARN_API + "/delete-exam?token=yoclass&user_id=" + userId+"&exam_key="+exam.exam_key).then(
                                    data => {
                                        if(data.status==200){
                                            message.success("Xóa đề thành công");
                                            for(let i=0;i<this.lstExam.length;i++){
                                                if(this.lstExam[i].exam_key == exam.exam_key){
                                                    this.lstExam.splice(i,1);
                                                    if(this.lstExam.length>0){
                                                        if(i<this.lstExam.length) {
                                                            this.exam = this.lstExam[i];
                                                            this.examId = this.exam.exam_id;
                                                        } else {
                                                            this.exam = this.lstExam[this.lstExam.length-1];
                                                            this.examId = this.exam.exam_id;
                                                        }
                                                    } else {
                                                        console.log("dsfdsf");
                                                        this.exam = null;
                                                        this.examId = null;
                                                    }
                                                    break;
                                                }
                                            }

                                        }
                                    },
                                    error => {
                                        message.error(error);
                                    }
                                )
                */
            },

            viewMatrix: function (matrixId) {
                this.matrixId = matrixId;
                this.show = 2;
            },

            selectExamId(examId) {
                let url = process.env.VUE_APP_YO_LEARN_API + "/exams/exam_detail?token=yoclass&exam_id=" + examId;
                axios.get(url).then(
                    data => {
                        this.onSelectExam(data);
                    },
                    error => {
                        console.log(error);
                    }
                )

            },

            onSelectExam(exam) {
                console.log("matrixPage exam");
                console.log("select exam");
                this.$emit("save", exam);
                //this.$emit("cancel");
            },

            cancelCreate: function () {
                this.show = 1;
                this.getMatrix();
            },

            cancel: function () {
                this.$emit("cancel");
            }
        }
    };
</script>